module.exports = __webpack_public_path__ + "static/media/Cryogonal_gaussian2.af1d279a.png";